'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': '访问辅助功能',
  'access-ad': '访问 ad',
  'access-assist-listening': '访问辅助听力',
  'access-braille': '访问盲文',
  'access-sign': '访问标志',
  'access-tty': '访问 tty',
  'access-volume-control': '访问音量控制',
  'access-wheelchair-active': '访问轮椅活动',
  'access-wheelchair': '访问轮椅',
  'achievement': '成果',
  'action': '操作',
  'actions': '操作',
  'add-circle': '添加循环',
  'add': '添加',
  'aggregate': '聚合',
  'aid': '辅助',
  'alarm': '警报',
  'alert': '警报',
  'analytics': '分析',
  'announce': '通告',
  'apps': '应用程序',
  'archive': '存档',
  'article': '文章',
  'ascend': '升序',
  'attachment': '附件',
  'back-ten': '后退十步',
  'bar-chart': '条形图',
  'basket': '购物篮',
  'blog': '博客',
  'book': '书',
  'bookmark': '书签',
  'bottom-corner': '底角',
  'brand-apple-app-store': 'apple 品牌应用商店',
  'brand-codepen-edit': 'codepen 品牌编辑',
  'brand-codepen-try': 'codepen 品牌尝试',
  'brand-google-play': 'google play 品牌',
  'brand-grommet-outline': 'grommet 品牌轮廓',
  'brand-grommet-path': 'grommet 品牌路径',
  'brand-hpe-element-outline': 'hpe 品牌元素轮廓',
  'brand-hpe-element-path': 'hpe 品牌元素路径',
  'brand-hpe-labs-insignia-outline': 'hpe 品牌实验室徽章轮廓',
  'brand-hpe-labs-insignia': 'hpe 品牌实验室徽章',
  'brand-hpe-stack-centered': 'hpe 品牌堆栈居中',
  'brand-hpe-stack': 'hpe 品牌堆栈',
  'briefcase': '公文包',
  'brush': '刷子',
  'bug': '缺陷',
  'bundle': '包',
  'business-service': '业务服务',
  'calculator': '计算器',
  'calendar': '日历',
  'camera': '相机',
  'capacity': '容量',
  'car': 'car',
  'caret-down': '脱字号下',
  'caret-next': '脱字号后',
  'caret-previous': '脱字号前',
  'caret-up': '脱字号上',
  'cart': '购物车',
  'catalog': '目录',
  'chapter-add': '添加章',
  'chapter-next': '下一章',
  'chapter-previous': '上一章',
  'chat': '聊天',
  'checkbox-selected': '复选框选中',
  'checkbox': '复选框',
  'checkmark': '复选标记',
  'circle-information': '循环信息',
  'circle-play': '循环播放',
  'circle-question': '循环问题',
  'clear-option': '清除选项',
  'clear': '清除',
  'cli': 'cli',
  'clipboard': '剪贴板',
  'clock': '时钟',
  'clone': '克隆',
  'close': '关闭',
  'closed-caption': '隐藏字幕',
  'cloud-computer': '云计算机',
  'cloud-download': '云下载',
  'cloud-software': '云软件',
  'cloud-upload': '云上载',
  'cloud': '云',
  'cluster': '群集',
  'code': '代码',
  'columns': '列',
  'compare': '比较',
  'compass': '指南针',
  'compliance': '合规性',
  'configure': '配置',
  'connect': '连接',
  'contact-info': '联系人信息',
  'contact': '联系人',
  'contract': '合同',
  'copy': '复制',
  'credit-card': '信用卡',
  'cube': '立方形',
  'cubes': '立方形',
  'currency': '货币',
  'cursor': '光标',
  'cut': '剪切',
  'cycle': '周期',
  'dashboard': '控制面板',
  'database': '数据库',
  'deliver': '提供',
  'deploy': '部署',
  'descend': '降序',
  'desktop': '桌面',
  'detach': '分离',
  'diamond': '钻石',
  'directions': '方向',
  'dislike': '踩',
  'document-cloud': '文档云',
  'document-config': '文档配置',
  'document-csv': 'csv 文档',
  'document-download': '文档下载',
  'document-excel': 'excel 文档',
  'document-exe': 'exe 文档',
  'document-image': '图像文档',
  'document-locked': '文档被锁定',
  'document-missing': '文档丢失',
  'document-notes': '文档注释',
  'document-outlook': 'outlook 文档',
  'document-pdf': 'pdf 文档',
  'document-performance': '文档性能',
  'document-ppt': 'ppt 文档',
  'document-rtf': 'rtf 文档',
  'document-sound': '声音文档',
  'document-store': '文档存储',
  'document-test': '文档测试',
  'document-threat': '文档威胁',
  'document-time': '文档时间',
  'document-transfer': '文档传输',
  'document-txt': 'txt 文档',
  'document-update': '文档更新',
  'document-upload': '文档上载',
  'document-user': '文档用户',
  'document-verified': '已验证文档',
  'document-video': '视频文档',
  'document-windows': 'Windows 文档',
  'document-word': 'word 文档',
  'document-zip': 'zip 文档',
  'document': '文档',
  'domain': '域',
  'down': '下',
  'download': '下载',
  'drag': '拖动',
  'drive-cage': '驱动器固定架',
  'duplicate': '重复',
  'edit': '编辑',
  'eject': '弹出',
  'empty-circle': '空循环',
  'expand': '展开',
  'fan': '风扇',
  'fast-forward': '快进',
  'favorite': '收藏',
  'filter': '筛选',
  'finger-print': '指纹',
  'flag': '标志',
  'folder-cycle': '文件夹刷新',
  'folder-open': '文件夹已打开',
  'folder': '文件夹',
  'forward-ten': '前进十步',
  'gallery': '画廊',
  'gamepad': '游戏板',
  'gift': '礼物',
  'globe': '全球',
  'grid': '网格',
  'group': '组',
  'grow': '增长',
  'halt': '停止',
  'help': '帮助',
  'history': '历史记录',
  'home': '主页',
  'host-maintenance': '主机维护',
  'host': '主机',
  'image': '映像',
  'impact': '影响',
  'in-progress': '正在进行',
  'inbox': '收件箱',
  'indicator': '指标',
  'info': '信息',
  'inherit': '继承',
  'inspect': '检查',
  'install': '安装',
  'integration': '集成',
  'iteration': '迭代',
  'java': 'java',
  'language': '语言',
  'launch': '启动',
  'layer': '层',
  'license': '许可',
  'like': '赞',
  'line-chart': '折线图',
  'link-bottom': '链接底部',
  'link-down': '链接中断',
  'link-next': '下一个链接',
  'link-previous': '上一个链接',
  'link-top': '链接顶部',
  'link-up': '链接连通',
  'link': '链接',
  'local': '本地',
  'location-pin': '定位销',
  'location': '位置',
  'lock': '锁',
  'login': '登录',
  'logout': '注销',
  'magic': '魔力',
  'mail-option': '邮件选项',
  'mail': '邮件',
  'manual': '手动',
  'map-location': '地图位置',
  'map': '地图',
  'menu': '菜单',
  'microphone': '麦克风',
  'money': '资金',
  'monitor': '监控',
  'more': '更多',
  'multiple': '多个',
  'navigate': '导航',
  'new-window': '新窗口',
  'new': '新',
  'next': '下一页',
  'nodes': '节点',
  'note': '注释',
  'notes': '备注',
  'notification': '通知',
  'object-group': '对象分组',
  'object-ungroup': '取消组合对象',
  'optimize': '优化',
  'organization': '组织',
  'overview': '概述',
  'pan': '平移',
  'pause-fill': '暂停填充',
  'pause': '暂停',
  'personal-computer': '个人计算机',
  'pie-chart': '饼图',
  'pin': '大头针',
  'plan': '计划',
  'platform-amazon': 'amazon 平台',
  'platform-android': 'android 平台',
  'platform-apple': 'apple 平台',
  'platform-archlinux': 'archlinux 平台',
  'platform-aruba': 'aruba 平台',
  'platform-centos': 'centos 平台',
  'platform-chrome': 'chrome 平台',
  'platform-cloudlinux': 'cloudlinux 平台',
  'platform-debian': 'debian 平台',
  'platform-docker': 'docker 平台',
  'platform-dos': 'dos 平台',
  'platform-dropbox': 'dropbox 平台',
  'platform-edge': 'edge 平台',
  'platform-fedora': 'fedora 平台',
  'platform-firefox': 'firefox 平台',
  'platform-freebsd': 'freebsd 平台',
  'platform-google': 'google 平台',
  'platform-hadoop': 'hadoop 平台',
  'platform-heroku': 'heroku 平台',
  'platform-horton': 'horton 平台',
  'platform-hp': 'hp 平台',
  'platform-hpi': 'hpi 平台',
  'platform-internet-explorer': 'internet explorer 平台',
  'platform-java': 'java 平台',
  'platform-mandriva': 'mandriva 平台',
  'platform-mysql': 'mysql 平台',
  'platform-norton': 'norton 平台',
  'platform-onedrive': 'onedrive 平台',
  'platform-opera': 'opera 平台',
  'platform-oracle': 'oracle 平台',
  'platform-pied-piper': 'pied piper 平台',
  'platform-raspberry': 'raspberry 平台',
  'platform-reactjs': 'reactjs 平台',
  'platform-redhat': 'redhat 平台',
  'platform-safari-option': 'safari 平台选项',
  'platform-safari': 'safari 平台',
  'platform-sco': 'sco 平台',
  'platform-solaris': 'solaris 平台',
  'platform-suse': 'suse 平台',
  'platform-swift': 'swift 平台',
  'platform-turbolinux': 'turbolinux 平台',
  'platform-ubuntu': 'ubuntu 平台',
  'platform-unixware': 'unixware 平台',
  'platform-vmware': 'vmware 平台',
  'platform-windows-legacy': 'windows 旧版平台',
  'platform-windows': 'windows 平台',
  'play-fill': '播放填充',
  'play': '播放',
  'power': '电源',
  'previous': '上一页',
  'print': '打印',
  'radial-selected': '径向选择',
  'radial': '径向',
  'refresh': '刷新',
  'resources': '资源',
  'resume': '继续',
  'revert': '恢复',
  'rewind': '倒带',
  'risk': '风险',
  'robot': '机器人',
  'rss': 'rss',
  'run': '运行',
  'satellite': '卫星',
  'save': '保存',
  'scan': '扫描',
  'schedule-new': '新建计划',
  'schedule-play': '播放计划',
  'schedule': '计划',
  'schedules': '计划',
  'scorecard': '记分卡',
  'search-advanced': '高级搜索',
  'search': '搜索',
  'secure': '安全',
  'select': '选择',
  'selection': '选择',
  'send': '发送',
  'server-cluster': '服务器群集',
  'server': '服务器',
  'servers': '服务器',
  'service-play': '播放服务',
  'services': '服务',
  'settings-option': '设置选项',
  'share': '共享',
  'shield-security': '安全防护',
  'shield': '防护',
  'shift': '转变',
  'sidebar': '侧栏',
  'social-amazon': 'amazon 社交',
  'social-amex': 'amex 社交',
  'social-bitcoin': 'bitcoin 社交',
  'social-codepen': 'codepen 社交',
  'social-creative-commons': 'creative commons 社交',
  'social-dropbox': 'dropbox 社交',
  'social-facebook-option': 'facebook option 社交',
  'social-facebook': 'facebook 社交',
  'social-github': 'github 社交',
  'social-google-plus': 'google plus 社交',
  'social-google-wallet': 'google wallet 社交',
  'social-instagram': 'instagram 社交',
  'social-linkedin-option': 'linkedin option 社交',
  'social-linkedin': 'linkedin 社交',
  'social-mail': 'mail 社交',
  'social-mastercard': 'mastercard 社交',
  'social-medium': 'medium 社交',
  'social-paypal': 'paypal 社交',
  'social-pinterest': 'pinterest 社交',
  'social-product-hunt': 'product hunt 社交',
  'social-reddit': 'reddit 社交',
  'social-skype': 'skype 社交',
  'social-slack': 'slack 社交',
  'social-snapchat': 'snapchat 社交',
  'social-square': 'square 社交',
  'social-stack-overflow': 'stack overflow 社交',
  'social-stripe': 'stripe 社交',
  'social-tumblr': 'tumblr 社交',
  'social-twitter': 'twitter 社交',
  'social-vimeo': 'vimeo 社交',
  'social-vine': 'vine 社交',
  'social-visa': 'visa 社交',
  'social-wordpress': 'wordpress 社交',
  'social-youtube': 'youtube 社交',
  'sort': '排序',
  'split': '拆分',
  'splits': '拆分',
  'stakeholder': '利益相关者',
  'standards-3d-effects': '3d 效果标准',
  'standards-connectivity': '连接标准',
  'standards-css3': 'css3 标准',
  'standards-device': '设备标准',
  'standards-fireball': 'fireball 标准',
  'standards-html5': 'html5 标准',
  'standards-multimedia': '多媒体标准',
  'standards-offline-storage': '脱机存储标准',
  'standards-performance': '性能标准',
  'standards-sematics': '语义标准',
  'star-half': '半星',
  'star': '星级',
  'steps': '步骤',
  'stop-fill': '停止填充',
  'stop': '停止',
  'storage': '存储',
  'street-view': '街景',
  'subtract-circle': '减去循环',
  'subtract': '减去',
  'support': '支持',
  'sync': '同步',
  'system': '系统',
  'table-add': '添加表',
  'table': '表',
  'tag': '标记',
  'target': '目标',
  'task': '任务',
  'tasks': '任务',
  'technology': '技术',
  'template': '模板',
  'terminal': '终端',
  'test-desktop': '测试桌面',
  'test': '测试',
  'text-wrap': '文字环绕',
  'threats': '威胁',
  'ticket': '记录单',
  'tools': '工具',
  'tooltip': '工具提示',
  'top-corner': '顶角',
  'transaction': '交易',
  'trash': '垃圾',
  'tree': '树',
  'trigger': '触发',
  'trophy': '奖品',
  'troubleshoot': '疑难解答',
  'unlink': '取消链接',
  'unlock': '解锁',
  'up': '上',
  'update': '更新',
  'upgrade': '升级',
  'upload': '上载',
  'user-add': '添加用户',
  'user-admin': '管理员用户',
  'user-expert': '专家用户',
  'user-female': '女性用户',
  'user-manager': '用户管理器',
  'user-new': '新用户',
  'user-police': '警察用户',
  'user-settings': '用户设置',
  'user-worker': '工人用户',
  'user': '用户',
  'validate': '验证',
  'video': '视频',
  'view': '查看',
  'virtual-machine': '虚拟机',
  'vm-maintenance': '虚拟机维护',
  'volume-low': '音量低',
  'volume-mute': '静音',
  'volume': '音量',
  'vulnerability': '漏洞',
  'waypoint': '路径点',
  'workshop': '工作室',
  'zoom-in': '放大',
  'zoom-out': '缩小'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/zh-CN.js
// module id = 130
// module chunks = 0